module.exports = __webpack_public_path__ + "static/media/brand-banner.7a1ea097.png";